// extracted by mini-css-extract-plugin
export default {"cols":"Dashboard_cols__DC2ZI","item":"Dashboard_item__98ZIQ","wrapper":"Dashboard_wrapper__rvlxh"};